"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.T2 = exports.T3 = exports.SectionTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = function className(props, type) {
  return (0, _classnames.default)('Title', {
    'Title--brand': props.brand,
    'Title--dim': props.dim
  }, {
    'Title--main': type === 'primary',
    'Title--subtitle': type === 'secondary',
    'Title--tertiary': type === 'tertiary',
    'Title--section': type === 'section'
  }, props.className);
};

var SectionTitle = function SectionTitle(props) {
  var style = props.style,
      children = props.children,
      rest = _objectWithoutProperties(props, ["style", "children"]);

  return _react.default.createElement("div", _extends({}, (0, _omit.default)(rest, ['brand', 'dim']), {
    className: className(props, 'section'),
    style: style
  }), children);
};

exports.SectionTitle = SectionTitle;

var T3 = function T3(props) {
  var style = props.style,
      children = props.children,
      rest = _objectWithoutProperties(props, ["style", "children"]);

  return _react.default.createElement("div", _extends({}, (0, _omit.default)(rest, ['brand', 'dim']), {
    className: className(props, 'tertiary'),
    style: style
  }), children);
};

exports.T3 = T3;

var T2 = function T2(props) {
  var style = props.style,
      children = props.children,
      rest = _objectWithoutProperties(props, ["style", "children"]);

  return _react.default.createElement("div", _extends({}, (0, _omit.default)(rest, ['brand', 'dim']), {
    className: className(props, 'secondary'),
    style: style
  }), children);
};

exports.T2 = T2;

var T1 = function T1(props) {
  var style = props.style,
      children = props.children,
      rest = _objectWithoutProperties(props, ["style", "children"]);

  return _react.default.createElement("h1", _extends({}, (0, _omit.default)(rest, ['brand', 'dim']), {
    className: className(props, 'primary'),
    style: style
  }), children);
};

var _default = T1;
exports.default = _default;